import { useMutation } from '@tanstack/react-query';
import { removeFavorites } from '~/apis/pms';

export const useDeleteRemoveFavorite = () => {
  return useMutation({
    mutationFn: (params: Parameters<typeof removeFavorites>[0]) => removeFavorites(params),
  });
};
